import Cookies from 'js-cookie'
import apiClient from '../../services/apiClient'

export const fetchRolePermissions = async (Token, Role, operations) => {
  if (Array.isArray(operations) && operations.length) {
    Cookies.set('Permissons', JSON.stringify(operations))
    return operations
  }

  // Explicit Authorization header: this runs right after login, before the
  // ClaccessToken cookie apiClient reads by default is set, so it must pass
  // the just-issued token directly. apiClient's interceptor never overrides
  // an Authorization header that's already set.
  const res = await apiClient.get('/roles/my-permissions', {
    headers: {
      Authorization: `Bearer ${Token}`,
    },
  })
  const fromLogin = res?.data?.data?.operations
  if (Array.isArray(fromLogin) && fromLogin.length) {
    Cookies.set('Permissons', JSON.stringify(fromLogin))
    return fromLogin
  }

  const userPermissions = (res?.data?.data?.rolePermissions || [])
    .filter(p => p.roleId?.name === Role)
    .map(p => p.permissionId.operation)

  Cookies.set('Permissons', JSON.stringify(userPermissions))
  return userPermissions
}
